module.exports = __webpack_public_path__ + "static/media/ondemand_entrance.8c5b5267.png";